import { CalendarSearchService } from './../../@core/mock/calendar-search.service';
import { NgModule } from '@angular/core';
import {
  NbActionsModule,
  NbButtonModule,
  NbCardModule,
  NbTabsetModule,
  NbUserModule,
  NbRadioModule,
  NbSelectModule,
  NbListModule,
  NbIconModule,
  NbCalendarKitModule,
  NbCalendarModule,
  NbCalendarRangeModule,
  NbAccordionModule,
} from '@nebular/theme';
import { NgxEchartsModule } from 'ngx-echarts';

import { ThemeModule } from '../../@theme/theme.module';
import { CalendarSearchComponent } from './calendar-search.component';
import { LeafletModule } from '@asymmetrik/ngx-leaflet';
import { CalendarComponent } from './calendar/calendar.component';
import { FormsModule } from '@angular/forms';
import { DayCellComponent } from './calendar/day-cell/day-cell.component';
import { AccordionComponent } from './accordion/accordion.component';

@NgModule({
  imports: [
    FormsModule,
    ThemeModule,
    NbCardModule,
    NbUserModule,
    NbButtonModule,
    NbTabsetModule,
    NbActionsModule,
    NbRadioModule,
    NbSelectModule,
    NbListModule,
    NbIconModule,
    NbButtonModule,
    NgxEchartsModule,
    LeafletModule,
    NbCalendarKitModule,
    NbCalendarModule,
    NbCalendarRangeModule,
    NbAccordionModule,
  ],
  declarations: [
    DayCellComponent,
    CalendarSearchComponent,
    CalendarComponent,
    AccordionComponent,
  ],
  providers: [
    CalendarSearchService,
  ],
})
export class CalendarSearchModule { }
